import React from 'react';

import { QueryProvider } from '@thd-nucleus/data-sources';
import { Package } from './Package';

export const PackageContainer = () => {
  return (
    <QueryProvider cacheKey="package-experience">
      <Package />
    </QueryProvider>
  )
};